module.exports = __webpack_public_path__ + "img/vendors_img.4e763515.svg";